var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Progetti",
    "data-name": "icona Titolo Progetti",
    transform: "translate(-33 -271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_6",
    "data-name": "Rettangolo 6",
    transform: "translate(33 271)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 29.4,
    height: 29.4,
    rx: 1.7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2",
    "data-name": "Raggruppa 2",
    transform: "translate(37.286 273.143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7",
    "data-name": "Rettangolo 7",
    width: 4.286,
    height: 23.571,
    rx: 2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_8",
    "data-name": "Rettangolo 8",
    width: 4.286,
    height: 12.857,
    rx: 2,
    transform: "translate(8.571)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_9",
    "data-name": "Rettangolo 9",
    width: 4.286,
    height: 17.143,
    rx: 2,
    transform: "translate(17.143)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTitle);
export default __webpack_public_path__ + "static/media/project_title.ab2a7cdb54295c3d56f811029b238793.svg";
export { ForwardRef as ReactComponent };